'use strict';
'strict';

var fetch = require('cross-fetch');

module.exports = function (pkgName) {
  var URL = 'https://unpkg.com/' + pkgName + '/package.json';
  return fetch(URL, { json: true }).then(function (res) {
    var statusCode = res.status;
    switch (statusCode) {
      case 200:
        return res.json();
      case 404:
        throw new Error('Package `' + pkgName + '` doesn\'t exist');
      default:
        throw new Error('Something is wrong.');
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/unpkg-json/dist/index.js
// module id = 781
// module chunks = 0